import { render, staticRenderFns } from "./AccountingTransferPosting.vue?vue&type=template&id=4af2de70&scoped=true"
import script from "./AccountingTransferPosting.vue?vue&type=script&lang=js"
export * from "./AccountingTransferPosting.vue?vue&type=script&lang=js"
import style0 from "./AccountingTransferPosting.vue?vue&type=style&index=0&id=4af2de70&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4af2de70",
  null
  
)

export default component.exports